/* eslint-disable */
import { useState, useEffect } from 'react';
import Info from '@/Components/InfoTab/Info';
import Tab from '@/Components/InfoTab/tab';
import { convertWeightUnit, formatDateOneLiner, inputHelper, keyPressHandler, useProductData, useQuery } from '@/Helpers';
import { useHistory } from 'react-router-dom';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import GrnHeader from './grnHeader';
import useKeyPress from '@/Helpers/useKeyPress';
import { urls } from '@/Constants';
import { BackdropLoader } from '@/Components/Loaders';
import { notificationServices } from '@/Services';
import GrnTable from './GrnTable';
import { Chip } from '@mui/material';
import { grnQcLogService } from '@/Services/grnQcLog.services';
import { ListTable } from '@/Components/ListTable';
import { DownloadIcon } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { analyticsAction, modalActions } from '@/Actions';
import utilsServices from '@/Services/utilsServies.services';
import DocumentsImagesSection from '../Analytics/Inventory Analytics/PurchaseOrderList/DocumnetSection';
import { DocumentModal } from '../Analytics/Inventory Analytics/PurchaseOrderList/docModal';

const tabList = [
    {
        value: 'orderedProducts',
        label: 'Ordered Products',
    },
    {
        value: 'aiMachineGrnLogs',
        label: 'AI Supervisor Scans',
    },
    {
        value: 'documents',
        label: 'Documents',
    }
];

const COLMAP = {
    'Variant Name': 'id',
    'Category': 'id',
    'Sub Category': 'id',
    'Sku Code': 'id',
    'Unit': 'unit',
    'PO Quantity': 'poQty',
    'GRN Quantity': 'qty',
    'Scanned/Measured Quantity': 'extraData',
    'Fullfiled Quantity': 'fulfilled',
    'Batch Fullfiled': 'id',
    'Qc Passed': 'id',
    'View QC Logs': 'id',
};

const SPECIAL_COLUMNS = [
    {
        title: 'Variant Name',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Category',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Sub Category',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Sku Code',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Unit',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'PO Quantity',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'GRN Quantity',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Fullfiled Quantity',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Scanned/Measured Quantity',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Batch Fullfiled',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Qc Passed',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'View QC Logs',
        config: {
            type: 'DATA',
        },
    },
];

// feilds
const aiMachineColMap = {
    'UY Id': 'id',
    'Store': 'storeName',
    'QC Time': 'QCTime',
    'Result': 'result',
    'Order ID': 'OrderId',
    'Product Name': 'ProductName',
    'Category': 'categoryName',
    'Sub Category': 'subCategoryName',
    'Sku Code': 'clientVariantId',
    'Net Quantity': 'id',
    'Temp': 'Temp',
};

const aiMachineSpecialColumns = [
    {
        title: 'UY Id',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Store',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'QC Time',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Order ID',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Product Name',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Category',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Sub Category',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Sku Code',
        config: {
            type: 'DATA',
        },
    },
    {
        title: 'Net Quantity',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Temp',
        config: {
            type: 'Data',
        },
    },
    {
        title: 'Result',
        config: {
            type: 'Data',
        },
    },
];

const fieldMap = {
    'PO Id': 'clientPoId',
    'Vendor Name': 'vendorName',
    'Store Name': 'storeName',
    'Fullfilled Quantity': 'fullfilledQuantity',
    'GRN Start At': 'grnStartDate',
    'GRN End At': 'grnEndDate',
    // 'Start Time': 'startTime',
    // 'End Time': 'endTime',
    'Duration': 'duration',
};

function GRNDetailsPage() {
    const query = useQuery();
    const history = useHistory();
    const id = query?.get('id');
    const listData = useSelector((state) => state.wastage.grnList);
    const [idx, setIdx] = useState(-1);
    const keyPressed = useKeyPress();
    const [grnDetails, setGrnDetails] = useState({
        id: '',
        status: '',
        clientPoId: '',
        vendorName: '',
        storeName: '',
        fullfilledQuantity: 0,
        grnStartDate: '',
        grnEndDate: '',
        startTime: '',
        endTime: '',
        duration: '',
    });
    const [data, setData] = useState({});
    const [grnData, setGrnData] = useState([]);
    const queryParams = useQuery();
    const [tabValue, setTabValue] = useState('orderedProducts');
    const [documentsData, setDocumentsData] = useState([]);
    const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
    const aiGrnScanList = useSelector(
        (state) => state.analytics.QUALITY_ANALYTICS.SEARCH_DATA.list
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if (Array.isArray(products) && products?.length === 0) {
            useProductData(dispatch);
        }
    }, [products]);

    useEffect(() => {
        if (listData?.length > 0) {
            const fetchDoc = async () => {
                let docData = [];
                let urls = [];
                const listObj = listData?.find((item) => item?.id == id);
                const docFields = {
                    uploadedDoc_db: listObj?.uploadedDoc_db,
                    generatedDoc_db: listObj?.generatedDoc_db,
                };
                docData = Object.values(docFields).filter((url) => url != null && url !== undefined && url !== '');
                try {
                    const response = await utilsServices?.getBase64FromFileUrl({
                        data: {
                            docUrls: docData,
                        },
                    });
                    if (response?.statusCode === 200) {
                        const respData = response?.data;
                        let entries = [];
                        entries = Object.entries(respData);
                        entries.forEach(([key, value]) => {
                            if (docFields?.generatedDoc_db === key) {
                                const name = (typeof key === 'string' && key.includes(':')) ? key.split(':')[1] : `Generated Doc ${listObj?.id}`;
                                urls.push({
                                    name,
                                    type: '',
                                    uploadedDate: listObj?.updatedAt,
                                    base64url: value,
                                    url: listObj?.generatedDoc,
                                });
                            }
                            if (docFields?.uploadedDoc_db === key) {
                                urls.push({
                                    name: `Invoice ${listObj?.id} Grn`,
                                    type: '',
                                    uploadedDate: listObj?.updatedAt,
                                    base64url: value,
                                    url: listObj?.uploadedDoc,
                                });
                            }
                        });
                    }
                    setDocumentsData(urls);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchDoc();
        }
    }, [listData, id]);


    useEffect(() => {
        if (!id) {
            history.push(`${urls.EXTENSION}${urls.GRN_LIST}`);
            return;
        }
    }, []);

    useEffect(() => {
        if (listData?.length > 0) {
            const currentIndex = listData.findIndex(
                (item) => item.id === Number(id)
            );
            setIdx(currentIndex);
        }
    }, [id, listData]);

    const handleAiMachineFetch = async (id) => {
        const req = {
            data: {
                grnId: id,
                qcType: 'INWARD',
                onlyMachineScans: true,
            },
        }
        try {
            const res = await grnQcLogService.fetchAiSupervisorScans(req);
            if (res?.statusCode === 200) {
                dispatch(analyticsAction.setAiQualityListScan(res?.data));
                notificationServices.generateNotification({
                    type: 'success',
                    message: 'Data fetched successfully',
                });
            }
        } catch (error) {
            notificationServices.generateNotification({
                type: 'error',
                message: error,
            });
        }
    }

    const fetchGrnDetails = async (grnId) => {
        if (!grnId) return;
        try {
            const responseData = await inventoryAnalyticsServices.fetchInvTransRecord({
                req: {
                    data: {
                        grnId: grnId,
                        type: 'GRN',
                    },
                },
            });
            if (responseData?.statusCode === 200 && responseData?.data?.length > 0) {
                const item = responseData?.data;
                const grnItem = item[0];
                setData(grnItem);
                setGrnDetails(() => {
                    return {
                        id: grnItem?.id || '',
                        status: grnItem?.transactionStatus || '',
                        clientPoId: grnItem?.clientPoId || '',
                        storeName: grnItem?.storeName || '',
                        vendorName: grnItem?.vendorName || '',
                        fullfilledQuantity: grnItem?.id || 0,
                        grnStartDate: grnItem?.createdAt || '',
                        grnEndDate: grnItem?.closedAt || '',
                        startTime: grnItem?.createdAt || '',
                        endTime: grnItem?.closedAt || '',
                        duration: grnItem?.id || '',
                        fullfilledQuantity: grnItem?.items?.reduce((acc, curr) => acc + Number(curr.fulfilled), 0),
                        totalQuantity: grnItem?.items?.reduce((acc, curr) => acc + Number(curr.qty), 0),
                        grnNumber: grnItem?.clientTransactionId || '',
                    };
                });
                setGrnData(grnItem?.items || []);
            }
        } catch (error) {
            console.error(error);
            notificationServices.generateNotification({
                type: 'error',
                message: 'Error fetching GRN details'
            });
        }
    };

    useEffect(() => {
        setTabValue('orderedProducts');
        if (id) {
            fetchGrnDetails(id);
        }
    }, [id]);

    const handleTabChange = (value) => {
        setTabValue(value);
        if (value === 'orderedProducts') {
            fetchGrnDetails(id);
        } else if (value === 'aiMachineGrnLogs') {
            handleAiMachineFetch(id);
        }
    };

    useEffect(() => {
        const qcData = listData?.[idx] ?? null;
        if (
            (keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
            qcData !== null
        ) {
            const newListItem = keyPressHandler(
                keyPressed,
                listData,
                idx
            );
            if (newListItem) {
                history.push({
                    pathname: `${urls.EXTENSION}${urls.GRN_DETAILS}`,
                    search: `id=${newListItem?.id}`,
                    state: {
                        from: history?.location?.state?.from,
                        search: history?.location?.state?.search,
                    },
                });
            }
        }
    }, [keyPressed]);

    const navigateQC = (e) => {
        const { dataset } = inputHelper(e);
        let newListItem = null;

        if (dataset.type === 'next') {
            newListItem = listData?.[idx + 1];
        } else {
            newListItem = listData?.[idx - 1];
        }

        if (newListItem) {
            history.push({
                pathname: `${urls.EXTENSION}${urls.GRN_DETAILS}`,
                search: `id=${newListItem?.id}`,
                state: {
                    from: history?.location?.state?.from,
                    search: history?.location?.state?.search,
                },
            });
        }
    };


    const specialFields = {
        'Fullfilled Quantity': (id, item) => {
            if (grnData?.length === 0) return '-';
            const percentage = (grnDetails.fullfilledQuantity / grnDetails.totalQuantity) * 100;
            return (
                <div>
                    <p className='font-medium'>{percentage.toFixed(2)}%</p>
                </div>
            );
        },
        'GRN Date': (id, item) => {
            if (!item) return '-';
            try {
                const date = new Date(item);
                return (
                    <div>
                        <p className='font-medium'>{date.toLocaleDateString()}</p>
                    </div>
                );
            } catch (error) {
                return '-';
            }
        },
        'Start Time': (id, item) => {
            if (!item) return '-';
            try {
                const date = new Date(item);
                return (
                    <div>
                        <p className='font-medium'>{date.toLocaleTimeString()}</p>
                    </div>
                );
            } catch (error) {
                return '-';
            }
        },
        'End Time': (id, item) => {
            if (!item) return '-';
            try {
                const date = new Date(item);
                return (
                    <div>
                        <p className='font-medium'>{date.toLocaleTimeString()}</p>
                    </div>
                );
            } catch (error) {
                return '-';
            }
        },
        'Duration': (id, item) => {
            const startDate = new Date(grnDetails.startTime);
            const endDate = new Date(grnDetails.endTime);
            const diffInMs = Number(endDate) - Number(startDate);
            if (isNaN(diffInMs)) return '-';

            const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

            let durationText = '';
            if (days > 0) durationText += `${days}d `;
            if (hours > 0) durationText += `${hours}h `;
            if (minutes > 0) durationText += `${minutes}m`;

            return (
                <div>
                    <p className='font-medium'>
                        {durationText || '0m'}
                    </p>
                </div>
            );
        },
    };

    const SPECIAL_ITEMS = {
        'Variant Name': (id, item) => {
            const displayName = grnData?.find((data) => data?.id === id);
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {displayName?.productName}({displayName?.variantName})
                </div>
            );
        },
        'Category': (id, item) => {
            const displayName = grnData?.find((data) => data?.id === id);
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {displayName?.categoryName}
                </div>
            );
        },
        'Sub Category': (id, item) => {
            const displayName = grnData?.find((data) => data?.id === id);
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {displayName?.subCategoryName}
                </div>
            );
        },
        'Sku Code': (id, item) => {
            const displayName = grnData?.find((data) => data?.id === id);
            const product = products?.find((product) => Number(product?.id) === Number(displayName?.productId));
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {product?.variants?.find((variant) => Number(variant?.id) === Number(displayName?.variantId))?.clientVariantId}
                </div>
            );
        },
        'Unit': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {item}
                </div>
            );
        },
        'PO Quantity': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {item ?? '-'}
                </div>
            );
        },
        'GRN Quantity': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {item ?? '-'}
                </div>
            );
        },
        'Fullfiled Quantity': (id, item) => {
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {item}
                </div>
            );
        },
        'Scanned/Measured Quantity' : (id, item) => {
            const variantId = grnData?.find((data) => data?.id === id)?.variantId;
            const scannedQty = data?.extraData?.originalQty?.[variantId]
            return (
                <div className='text-left text-[12px] text-nowrap'>
                   {scannedQty ?? '-'}
                </div>
            );
        },
        'Batch Fullfiled': (id, item) => {
            try {
                const foundItem = grnData?.find((data) => data?.id === id);
                if (!foundItem || !foundItem.batches) {
                    return (
                        <div className='text-left text-[12px] text-nowrap'>
                            0/0
                        </div>
                    );
                }

                const totalBatches = foundItem.batches.length;
                const passedBatches = foundItem.batches.filter(batch => batch?.status === 'GRN').length;

                return (
                    <div className='text-left text-[12px] text-nowrap'>
                        {passedBatches}/{totalBatches}
                    </div>
                );
            } catch (error) {
                return (
                    <div className='text-left text-[12px] text-nowrap'>
                        0/0
                    </div>
                );
            }
        },
        'Qc Passed': (id, item) => {
            try {
                const foundItem = grnData?.find((data) => data?.id === id);
                if (!foundItem || !foundItem.batches) {
                    return (
                        <div className='text-left text-[12px] text-nowrap'>
                            0/0
                        </div>
                    );
                }

                const totalBatches = foundItem.batches.length;
                const passedBatches = foundItem.batches.filter(batch => batch?.status === 'GRN').length;

                return (
                    <div className='text-left text-[12px] text-nowrap'>
                        {passedBatches}/{totalBatches}
                    </div>
                );
            } catch (error) {
                return (
                    <div className='text-left text-[12px] text-nowrap'>
                        0/0
                    </div>
                );
            }
        },
        'View QC Logs': (id, item) => {
            const productId = grnData?.find((data) => data?.id === id)?.productId;
            const obj = {
                orderType: 'grnQcLogs',
                productId: productId,
                grnId: grnDetails?.id,
            }
            const qty = grnData?.find((data) => data?.id === id)?.qty;
            return (
                <div>
                    {qty > 0 ? (
                        <Chip
                            size='small'
                            className=' w-[150px] p-[15px] font-bold'
                            label='View QC Logs'
                            onClick={() => {
                                const queryString = encodeURIComponent(JSON.stringify(obj));
                                window.open(`${urls.EXTENSION}${urls.QUALITY_LOGS}?state=${queryString}`, '_blank');
                            }}
                        />
                    ) : (
                        <div className='text-red-500'>No batch created</div>
                    )}
                </div>
            );
        },
    };

    const getStatusColor = (status) => {
        switch ((status || '').toUpperCase()) {
            case 'PASSED':
                return 'bg-green-100 text-green-700';
                break;
            case 'FAILED':
                return 'bg-red-100 text-red-700';
                break;
            case 'PENDING':
                return 'bg-orange-100 text-orange-700';
                break;
            default:
                return '';
        }
    }
    const aiMachineSpecialColumnsMappings = {
        'UY Id': (id, items) => {
            return <div className='text-left text-[12px] text-nowrap'>{items ?? '-'}</div>;
        },
        'Store': (id, items) => {
            return <div className='text-left text-[12px] text-nowrap'>{items ?? '-'}</div>;
        },
        'QC Time': (id, items) => {
            return <div className='text-left text-[12px] text-nowrap'>{items ?? '-'}</div>;
        },
        'Order ID': (id, items) => {
            return <div className='text-left text-[12px] text-nowrap'>{items ?? '-'}</div>;
        },
        'Product Name': (id, items) => {
            return <div className='text-left text-[12px] text-nowrap'>{items ?? '-'}</div>;
        },
        Category: (id, items) => {
            const item = aiGrnScanList?.find((ele) => {
                return ele?.id === id;
            });
            return <div className='text-left text-[12px] text-nowrap'>{products?.find((product) => Number(product?.id) === Number(item?.productId))?.categoryName ?? '-'}</div>;
        },
        'Sub Category': (id, items) => {
            const item = aiGrnScanList?.find((ele) => {
                return ele?.id === id;
            });
            return <div className='text-left text-[12px] text-nowrap'>{products?.find((product) => Number(product?.id) === Number(item?.productId))?.subCategoryName ?? '-'}</div>;
        },
        'Sku Code': (id, items) => {
            const item = aiGrnScanList?.find((ele) => {
                return ele?.id === id;
            });
            return <div className='text-left text-[12px] text-nowrap'>{products?.find((product) => Number(product?.id) === Number(item?.productId))?.variants?.find((variant) => Number(variant?.id) === Number(item?.variantId))?.clientVariantId ?? '-'}</div>;
        },
        'Net Quantity': (id, items) => {
            const obj = aiGrnScanList?.find((ele) => {
                return ele?.id === id;
            });
            const quantity = obj?.unit !== 'count' ? obj?.Weight : obj?.count;
            return (
                <div className='text-left text-[12px] text-nowrap'>
                    {convertWeightUnit(quantity, obj?.unit, undefined, true) ??
                        '-'}
                </div>
            );
        },
        'Temp': (id, items) => {
            return <div className='text-left text-[12px] text-nowrap'>{items ?? '-'}</div>;
        },
        'Result': (id, items) => {
            return <div className={`w-[10rem] min-h-[2rem] text-[12px] flex flex-col items-center justify-center rounded-[4px] font-semibold ${getStatusColor(items)}`}>{items ?? '-'}</div>;
        },
    };


    useEffect(() => {
        const searchParams = new URLSearchParams();
        const prevPath = history?.location?.state?.from;
        const prevSearch = history?.location?.state?.search;
        searchParams.set('tabValue', tabValue);
        searchParams.set('id', id);
        const search = searchParams.toString();
        history.replace({
            search: search ? `?${search}` : "", state: {
                from: prevPath,
                search: prevSearch,
            }
        });
    }, [tabValue]);

    useEffect(() => {
        const newQueryParams = {};
        if (query.get('tabValue')) {
            setTabValue(query.get('tabValue'));
            newQueryParams.tabValue = query.get('tabValue');
        }
        if (newQueryParams?.tabValue === 'aiMachineGrnLogs') {
            handleAiMachineFetch(id);
            setTabValue('aiMachineGrnLogs');
        } 
        // else {
        //     fetchGrnDetails(id);
        // }
    }, [id]);

    const handleViewDoc = (document, documents) => {
        dispatch(modalActions?.toggleDocumentModal(true, {
            obj: document, list: documents
        }));
    };

    const getStatus = (status) => {
        if (['LABELLING', 'VERIFICATION'].includes(status)) {
            return <span className='text-[#EA580C]'>In Progress</span>
        } else if (['ABANDONED'].includes(status)) {
            return <span className='text-[#5e5957]'>Abandoned</span>
        } else if (['FULFILLED'].includes(status)) {
            return <div className='text-[#15803D] ]'>Fulfilled</div>
        }
    }

    const backUrl = `${urls.EXTENSION}${urls.GRN_LIST}?${history?.location?.state?.search}`
    return (
        <div className="p-4">
            <DocumentModal />
            <GrnHeader
                navigateQC={navigateQC}
                idx={idx}
                listData={listData}
                id={grnDetails?.grnNumber}
                url={backUrl}
                title='Back to GRN Logs'
                navigateLabel='GRN Number'
            />
            <div className='relative top-[3rem]'>
                <Info
                    fieldMap={fieldMap}
                    data={grnDetails}
                    specialFields={specialFields}
                    heading={{
                        key: 'Status',
                        value: getStatus(grnDetails?.status),
                    }}
                />
                <Tab
                    tabList={tabList}
                    tabValue={tabValue}
                    handleTabChange={handleTabChange}
                />
                <div className='overflow-auto' style={{ maxHeight: '45vh' }}>
                    {tabValue === 'orderedProducts' &&
                        <GrnTable
                            data={grnData}
                            colMap={COLMAP}
                            special={SPECIAL_COLUMNS}
                            emptyText='No batch has been created'
                            specialMappings={SPECIAL_ITEMS}
                            tableType='orderedProducts'
                        />
                    }
                    {tabValue === 'aiMachineGrnLogs' &&
                        <GrnTable
                            data={aiGrnScanList}
                            colMap={aiMachineColMap}
                            special={aiMachineSpecialColumns}
                            specialMappings={aiMachineSpecialColumnsMappings}
                            tableType='aiMachineGrnLogs'
                        />
                    }
                    {tabValue === 'documents' &&
                        <DocumentsImagesSection
                            documents={documentsData}
                            handlePreview={handleViewDoc}
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default GRNDetailsPage;
